import React, { Component } from 'react';
import axios from 'axios';
import _ from 'lodash';

import { graphql } from 'react-apollo';

// Query
import query from '../../../../queries/fetchSurveyById';

// Components
import SingleMultipleAnswer from './SingleMultipleAnswer';
import OpenAnswer from './OpenAnswer';
import MixedAnswer from './MixedAnswer';

class FieldCollection extends Component {
	constructor(props) {
		super(props);
		this.state = {
			surveyId: this.props.surveyId,
			type: '',
			inputName: '',
			question: '',
			answers: [],
			config: {
				mostBeNum: false,
				numMin: '',
				numMax: ''
			}
		};
		this.handleOnChange = this.handleOnChange.bind(this);
		this.handleOnSubmit = this.handleOnSubmit.bind(this);
		this.parentStateCallback = this.parentStateCallback.bind(this);
	}
	handleEmptyValues() {
		if (this.state.config.mostBeNum) {
			const { numMin, numMax } = this.state.config;
			const emptyValues = _.some([numMin, numMax], value => value === '');
			if (emptyValues) {
				return true;
			}
		}
		const stateValues = _.valuesIn(_.omit(this.state, ['answers', 'config']));
		const emptyValues = _.some(stateValues, value => value === '');
		return emptyValues;
	}
	handleEmptyAnswers() {
		const emptyValues = _.isEmpty(this.state.answers);
		return emptyValues;
	}
	btnMode() {
		const { type } = this.state;
		if (this.handleEmptyValues()) {
			return 'btn btn-primary disabled';
		} else if (type !== 'open-question' && this.handleEmptyAnswers()) {
			return 'btn btn-primary disabled';
		}
		return 'btn btn-primary';
	}
	handleOnChange(e) {
		const { name, value } = e.target;
		if (value !== 'open-question') {
			this.clearStateConfig()
		}
		this.setState({
			[name]: value
		});
	}
	parentStateCallback(obj, type = 'default') {
		if (type === 'config') {
			return this.setState(prevState => {
				return {
					config: {
						...prevState.config,
						...obj
					}
				};
			});
		}
		this.setState(prevState => {
			return {
				answers: [...prevState.answers, obj]
			};
		});
	}
	clearState() {
		this.setState({
			type: '',
			inputName: '',
			question: '',
			answers: [],
			config: {
				mostBeNum: false,
				numMin: '',
				numMax: ''
			}
		});
	}
	clearStateConfig() {
		this.setState({
			...this.state,
			config: {
				mostBeNum: false,
				numMin: '',
				numMax: ''
			}
		});
	}
	handleOnSubmit(e) {
		const { type } = this.state;
		if (this.handleEmptyValues()) {
			return null;
		} else if (type !== 'open-question' && this.handleEmptyAnswers()) {
			return null;
		}
		const payload = this.state;
		const refetch = () => this.props.data.refetch();
		axios
			.post('/survey/add/fields', payload)
			.then(response => {
				refetch();
				this.clearState();
			})
			.catch(error => {
				console.log(error);
			});
	}
	renderQuestions() {
		const { type } = this.state;
		if (type === 'single-choice' || type === 'multiple-choice') {
			return (
				<React.Fragment>
					<SingleMultipleAnswer parentStateCallback={this.parentStateCallback} />
					<hr />
				</React.Fragment>
			);
		} else if (type === 'mixed-question') {
			return (
				<React.Fragment>
					<MixedAnswer parentStateCallback={this.parentStateCallback} />
					<hr />
				</React.Fragment>
			);
		} else if (type === 'open-question') {
			return (
				<React.Fragment>
					<OpenAnswer parentStateCallback={this.parentStateCallback} />
					<hr />
				</React.Fragment>
			);
		}
		return null;
	}
	render() {
		return (
			<React.Fragment>
				<div className="row">
					<div className="col-sm-6">
						<div className="form-group">
							<label>Pregunta</label>
							<textarea
								name="question"
								value={this.state.question}
								onChange={this.handleOnChange}
								className="form-control form-control-lg"
							/>
						</div>
					</div>
					<div className="col-sm-3">
						<div className="form-group">
							<label>Identificador</label>
							<input
								type="text"
								name="inputName"
								value={this.state.inputName}
								onChange={this.handleOnChange}
								className="form-control"
							/>
							<small className="form-text text-muted">
								Etiqueta para identificar esta pregunta. No utilice espacios o
								caracteres especiales.
							</small>
						</div>
					</div>
					<div className="col-sm-3">
						<div className="form-group">
							<label>Tipo de pregunta</label>
							<select
								value={this.state.type}
								onChange={this.handleOnChange}
								name="type"
								className="form-control"
							>
								<option value="">-- Seleccione --</option>
								<option value="open-question">Pregunta abierta</option>
								<option value="single-choice">Seleccion única</option>
								<option value="multiple-choice">Seleccion múltiple</option>
								<option value="mixed-question">Pregunta mixta</option>
							</select>
						</div>
					</div>
				</div>

				{!_.isEmpty(this.state.answers) && (
					<div className="form-group">
						<ul className="list-group">
							{_.map(this.state.answers, (answer, i) => (
								<li
									key={i}
									className="list-group-item list-group-item-success d-flex justify-content-between align-items-center"
								>
									{answer.label}
									<span className="badge badge-primary badge-pill">
										{answer.value}
									</span>
								</li>
							))}
						</ul>
					</div>
				)}

				{this.renderQuestions()}

				<button onClick={this.handleOnSubmit} className={this.btnMode()}>
					Guardar Pregunta
				</button>

				<br />
				<br />
			</React.Fragment>
		);
	}
}
export default graphql(query, {
	options: props => {
		return { variables: { id: props.surveyId } };
	}
})(FieldCollection);



// WEBPACK FOOTER //
// ./src/components/Survey/admin/FieldCollection/index.js